import r from '../core';

const getUserAPI = (userId, path) => {
  const userApiPrepend = userId ? `${API2_URL}users/${userId}/` : API_URL;
  return `${userApiPrepend}${path}`;
};

/**
 * Generate video request api.
 * This is done in such a "unique way because of how profile uses it."
 * TODO: Maybe it shouldn't be so unique after all
 */
const getUserVideoRequest = (path, options = {}) => {
  const params = {
    ...options.params,
  };
  const userId = params.id;
  delete params.id;

  const request = {
    url: getUserAPI(userId, path),
    params,
  };
  return request;
};

export default {
  get(userId, callback) {
    return r.get({
      url: `${API2_URL}users/${userId}`,
    }, callback);
  },

  getLikes(options, callback) {
    return r.get(getUserVideoRequest('likes', options), callback);
  },

  getVideos(options, callback) {
    return r.get(getUserVideoRequest('videos', options), callback);
  },

  /**
   * Return the playlists of a user
   * @param {Object} options for pagination
   * @param {*} callback
   * @returns {Object} response with returned pagination info and playlists {Array}
   */
  getPlaylists(options, callback) {
    if (!options.params) options.params = {};
    options.params.covers_per_list = 3;
    options.params.image_size = 'small';

    return r.get(getUserVideoRequest('playlists', options), callback);
  },

  /**
   * Return a playlist
   * @param {String} collectionId
   * @param {Object} options for pagination
   * @param {Function} callback
   * @returns {Object} collection
   */
  getPlaylist(collectionId, options, callback) {
    return r.get(getUserVideoRequest(`playlists/${collectionId}`, options), callback);
  },

  /**
   * Return a playlist
   * @param {String} collectionId
   * @param {Object} options for pagination
   * @param {*} callback
   * @returns {Object} collection
   */
  getPlaylistVideos(collectionId, options, callback) {
    return r.get(getUserVideoRequest(`playlists/${collectionId}/videos`, options), callback);
  },
};
